<ndt-two-column-list-layout>
   <ndt-schedule-register two-column-list-content-layout-list></ndt-schedule-register>
   <ndt-schedule-detail class="schedule-detail-column"></ndt-schedule-detail>
</ndt-two-column-list-layout>
